export default __webpack_public_path__ + "static/media/HUD-Effects-HUD Glitch.62a4bc31.jpg";